<template>
    <div class="course-container">

        <div class="header-wrapper">
            <div class="header-line-block"></div>
            <div class="header-title">课程管理 <span></span></div>
        </div>
        <div class="add-btn-wrapper">
            <div class="add-btn animate" @click="handleAdd">
                <img src="@/assets/img/pluss.png" alt="" class="add-plus-img" />
                添加课程组
            </div>
        </div>
        <div class="table-container">
            <div v-for="(item, key) in tableData" :key="key" class="table-row">
                <div class="table-content">
                    <div class="table-title">{{ item.courseGroupName }}</div>
                    <div class="table-info">
                        <div class="info-item">学员：{{ item.studyNumCount }}人</div>
                        <div class="info-line"></div>
                        <div class="info-item">点播：{{ item.recordCourseCount }}门</div>
                    </div>
                </div>
                <div class="btn-wrapper">
                    <div class="btn animate" @click="handleEdit(item)">编辑</div>
                    <div class="btn animate gap" @click="handleDelete(item)">删除</div>
                </div>
            </div>
        </div>

        <!--删除弹窗-->
        <el-dialog title="温馨提示" :visible.sync="deleteVisible" width="500px" :show-close="false">
            <div class="delete-dialog-wrapper">
                <div class="delete-dialog">
                    删除后学员的课程权限将自动被移除，是否继续此操作？
                </div>
                <div class="btn-wrapper">
                    <div class="btn cancel animate" @click="handleCancel">取消</div>
                    <div class="btn deal animate" @click="removeCourse">确定</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import { courseGroupList, deleteCourseGroup } from '@/api/index.js';
export default {
    name: '',
    components: {
        Header
    },
    data() {
        return {
            dept: '',
            token: '',
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            deleteVisible: false,
            activeRow: {}
        }
    },
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        // this.dept = this.$route.params.dept;
        // this.token = this.$route.params.token;
           this.token = localStorage.getItem('token');
        this.dept = localStorage.getItem('dept');
        this.getTableData();
    },
    methods: {
        async getTableData() {
            await courseGroupList({}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data;
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        handleDelete(row) {
            this.activeRow = row;
            this.deleteVisible = true;
        },
        handleCancel() {
            this.deleteVisible = false;
        },
        async removeCourse() {
            const id = this.activeRow.courseGroupId;
            await deleteCourseGroup(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.deleteVisible = false;
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getTableData();
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        handleAdd() {
            this.$router.push(`/CourseForm`)

            //  this.$emit('courseStatus', 'course-add');
        },
        handleEdit(row) {
            this.$router.push({
                path: "/CourseForm",
                query: {
                    data: JSON.stringify(row)
                }
            })
            // this.$emit('courseStatus', 'course-edit');
            // this.$emit('courseRow', JSON.stringify(row));
        }
    }
}
</script>

<style lang="less" scoped>
.animate {
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.course-container {
    width: 1200px;
    margin: 10px auto;
    height: 800px;

    overflow: hidden;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #F0F0F3;

    .header-wrapper {
        display: flex;
        align-items: center;
        margin-top: 32px;
        margin-bottom: 43px;
        position: relative;
        left: 0px;

        .header-line-block {
            width: 6px;
            height: 24px;
            background: #3E63EE;
            border-radius: 3px;
        }

        .header-title {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3E63EE;
            margin-left: 45px;
        }
    }

    .add-btn-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-right: 45px;

        .add-btn {
            width: 138px;
            height: 44px;
            background: #3E63EE;
            border-radius: 6px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;

            .add-plus-img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
                display: inline-block;
                position: relative;
                top: 1px;
            }
        }

        .add-btn:hover {
            cursor: pointer;
            opacity: 0.8;
        }
    }

    .table-container {
        width: 98%;
        margin: 0 auto;
        height: 660px;
        overflow-y: auto;

        .table-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 29px 0px 29px 0px;
            border-bottom: solid #F0F0F0 1px;

            .table-content {
                flex: 1;

                .table-title {
                    width: 90%;
                    font-size: 22px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    line-height: 30px;
                }

                .table-info {
                    display: flex;
                    align-items: center;
                    margin-top: 8px;
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #848F9A;
                    line-height: 25px;

                    .info-line {
                        width: 1px;
                        height: 14px;
                        background: #D7D7D7;
                        margin: 0px 11px 0px 11px;
                    }
                }
            }

            .btn-wrapper {
                display: flex;
                align-items: center;

                .btn {
                    width: 108px;
                    height: 44px;
                    border-radius: 6px;
                    border: 1px solid #3E63EE;
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #3E63EE;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .btn:hover {
                    cursor: pointer;
                    background: #3E63EE;
                    color: #fff;
                }

                .gap {
                    margin-left: 22px;
                }
            }
        }
    }

    /deep/ .el-dialog {
        box-shadow: 0px 2px 10px 4px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        border: 1px solid #EAEAEA;
    }

    /deep/ .el-dialog__header {
        height: 59px;
        background: #F7F7F8;
        padding: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }

    /deep/ .el-dialog__title {
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
    }

    /deep/ .el-dialog__body {
        padding: 0px;
    }

    .delete-dialog-wrapper {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        margin: 47px 74px 46px 74px;

        .btn-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 46px;

            .btn {
                width: 148px;
                height: 44px;
                border-radius: 6px;
                border: 1px solid #3E63EE;
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .cancel {
                color: #3E63EE;
            }

            .cancel:hover {
                cursor: pointer;
                background: #3E63EE;
                color: #fff;
            }

            .deal {
                background: #3E63EE;
                color: #fff;
            }

            .deal:hover {
                cursor: pointer;
                opacity: 0.8;
            }
        }
    }
}
</style>


